<template>
    <!-- Sidenav -->
  <nav class="sidenav navbar navbar-vertical  fixed-left  navbar-expand-xs navbar-light bg-white" id="sidenav-main">
    <div class="scrollbar-inner">
      <!-- Brand -->
      <div class="sidenav-header  d-flex  align-items-center">
        <a class="navbar-brand" href="../../pages/dashboards/dashboard.html">
          <!-- <img src="@/assets/img/brand/blue.png" class="navbar-brand-img" alt="..."> -->
          <h2>ROMANA V2</h2>
        </a>
        <div class=" ml-auto ">
          <!-- Sidenav toggler -->
          <div class="sidenav-toggler d-none d-xl-block" data-action="sidenav-unpin" data-target="#sidenav-main">
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="navbar-inner">
        <!-- Collapse -->
        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <!-- Nav items -->
          <ul class="navbar-nav">

            <li class="nav-item" v-for="(m,idx) in menus" :key="idx">

              <menu-solo v-if="m.ruta != '#'" :menu="m" @navegar="navegar($event)"></menu-solo>
              <menu-grupo v-if="m.ruta == '#'" :menu="m" @navegar="navegar($event)"></menu-grupo>
            </li>


            
            
            
            
            
            
            
          </ul>
          <!-- Divider -->
          <hr class="my-3">
          <!-- Heading -->
          <!-- <h6 class="navbar-heading p-0 text-muted">
            <span class="docs-normal">Documentation</span>
            <span class="docs-mini">D</span>
          </h6> -->
          <!-- Navigation -->
          <!-- <ul class="navbar-nav mb-md-3">
            <li class="nav-item">
              <a class="nav-link" href="https://demos.creative-tim.com/argon-dashboard-pro/docs/getting-started/overview.html" target="_blank">
                <i class="ni ni-spaceship"></i>
                <span class="nav-link-text">Getting started</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://demos.creative-tim.com/argon-dashboard-pro/docs/foundation/colors.html" target="_blank">
                <i class="ni ni-palette"></i>
                <span class="nav-link-text">Foundation</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://demos.creative-tim.com/argon-dashboard-pro/docs/components/alerts.html" target="_blank">
                <i class="ni ni-ui-04"></i>
                <span class="nav-link-text">Components</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://demos.creative-tim.com/argon-dashboard-pro/docs/plugins/charts.html" target="_blank">
                <i class="ni ni-chart-pie-35"></i>
                <span class="nav-link-text">Plugins</span>
              </a>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapState } from 'vuex'
import MenuGrupoVue from './MenuGrupo.vue';
import MenuSoloVue from './MenuSolo.vue';
export default {
  data:()=>({
  }),
  mounted(){
      ////console.log('menus',this.menus);
      
    },
  methods:{
    navegar(ruta){
      this.$router.push(`/${ruta}`)
    },
    
    retornarHTML(menu){
      return `
        
      `;
    }
  },
  computed:{
    ...mapState({
      menus:state => state.menus_rom
    })
  },
  components:{
    'menu-grupo':MenuGrupoVue,
    'menu-solo':MenuSoloVue
  }
}
</script>
<style>
.nav-item a.hoverito:hover{
  background-color: #c6cfe6;
  color: #fff;
}

.g-sidenav-show .sidenav .nav-link-text {
  transition: .3s ease;
  opacity: 1;
}
.g-sidenav-hidden:not(.g-sidenav-show) .sidenav .nav-link-text {
  opacity: 0;
}
</style>